import React, { Component } from "react";
import { Table, Button } from "antd";
import { PlusOutlined, PrinterOutlined } from "@ant-design/icons";

import { apiFeedback } from "../../../api/api-feedback";
import { emitter } from "../../../common/utils/emitter";
import { CAR_STATUS } from "../../../common/utils/static-data";
import { alert } from "../../../common/utils/alert";
import moment from "moment";

export class ReviewTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      total: 0,
    };

    this.page = 1;

    this.customerTable = [
      {
        title: "STT",
        dataIndex: "index",
        key: "index",
        maxWidth: 60,
      },
      {
        title: "Nội dung đánh giá",
        dataIndex: "",
        key: "",
        render: (data) => {
          let content = data.content
            .split(" ")
            .filter((item) => item !== "")
            .join(" ")
            .split("\n");
          let compactText = data.content
            .split(" ")
            .filter((item) => item !== "")
            .join(" ")
            .slice(0, 100)
            .split("\n");
          return (
            <div className="review-text">
              {!data.expand &&
                compactText.map((item, index) => {
                  if (
                    index === compactText.length - 1 ||
                    compactText.length === 1
                  ) {
                    return <span className="review-content">{item}</span>;
                  }
                  return (
                    <span className="review-content">
                      {item} <br />
                    </span>
                  );
                })}
              {data.expand &&
                content.map((item, index) => {
                  if (index === content.length - 1 || content.length === 1) {
                    return <span className="review-content">{item}</span>;
                  }
                  return (
                    <span className="review-content">
                      {item} <br />
                    </span>
                  );
                })}
              {data.content
                .split(" ")
                .filter((item) => item !== "")
                .join(" ").length > data.content.slice(0, 100).length &&
                data.expand === false && (
                  <>
                    {" "}
                    ...{" "}
                    <span
                      onClick={() => this.expandText(data)}
                      className="seeMore"
                    >
                      Xem thêm
                    </span>
                  </>
                )}
              {data.content
                .split(" ")
                .filter((item) => item !== "")
                .join(" ").length > data.content.slice(0, 100).length &&
                data.expand === true && (
                  <span
                    onClick={() => this.compactText(data)}
                    className="seeMore"
                  >
                    {" "}
                    Ẩn bớt
                  </span>
                )}
            </div>
          );
        },
      },
      {
        title: "Admin",
        dataIndex: "admin_name",
        key: "admin_name",
        render: (item) => (
          <div style={{ minWidth: 100, textAlign: "center" }}>{item}</div>
        ),
      },
      {
        title: "Khách hàng",
        dataIndex: "customer_name",
        key: "customer_name",
        render: (item) => (
          <div style={{ minWidth: 120, textAlign: "center" }}>{item}</div>
        ),
      },
      {
        title: "Thời gian",
        dataIndex: "created_at",
        key: "created_at",
        render: (item) => {
          const time_unix = moment(item).format("DD/MM/YYYY");
          return item ? <span>{time_unix}</span> : null;
        },
      },
    ];
  }

  expandText = (data) => {
    for (let i = 0; i < this.state.dataTable.length; i++) {
      if (this.state.dataTable[i].id === data.id) {
        let newDataTable = [...this.state.dataTable];

        newDataTable[i].expand = true;

        this.setState({
          dataTable: [...newDataTable],
        });
      }
    }
  };

  compactText = (data) => {
    for (let i = 0; i < this.state.dataTable.length; i++) {
      if (this.state.dataTable[i].id === data.id) {
        let newDataTable = [...this.state.dataTable];
        newDataTable[i].expand = false;
        this.setState({
          dataTable: [...newDataTable],
        });
      }
    }
  };

  getData = async (page) => {
    if (page) {
      this.page = page;
    } else {
      this.page = 1;
    }
    try {
      emitter.emit("FETCH_LOADING", true);
      const result = await apiFeedback.getFeedbacks(page);
      emitter.emit("FETCH_LOADING", false);
      if (result.status === "success") {
        const dataConvert = result.data.content.map((value, index) => {
          return {
            index: index + (page - 1) * 10 + 1,
            ...value,
            data: value,
            expand: false,
          };
        });
        this.setState(
          { dataTable: dataConvert, total: result.data.total_elements },
          () => {}
        );
      }
    } catch (error) {
      emitter.emit("FETCH_LOADING", false);
    }
  };

  componentDidMount() {
    this.getData(1);
  }

  onChangePage = (page) => {
    const element = document.getElementById("right-layout");
    element.scrollTo(0, 0);
    this.getData(page);
  };

  render() {
    const { dataTable, total } = this.state;
    return (
      <div className="review-table">
        <div
          style={{
            color: "#d20a30",
            paddingTop: "20px",
            fontSize: "1em",
            display: "flex",
            alignItems: "center",
          }}
        >
          Nhận xét đánh giá
        </div>
        <Table
          className="review-table-container"
          rowKey={(record) => record.id}
          style={{ width: "100%" }}
          dataSource={dataTable}
          pagination={{
            total,
            pageSize: 10,
            onChange: this.onChangePage,
            current: this.page,
          }}
          //pagination={false}
          scroll={{ x: true }}
          columns={this.customerTable}
        />
      </div>
    );
  }
}
